import Initializer from './_initializer'
import Root from './_root'
import Element from './_element'

export default function () {
  const doc = getComputedStyle(document.documentElement)
  const breakpoints = [
    ['XL', parseInt(doc.getPropertyValue('--xl'))],
    ['LG', parseInt(doc.getPropertyValue('--lg'))],
    ['MD', parseInt(doc.getPropertyValue('--md'))],
    ['SM', parseInt(doc.getPropertyValue('--sm'))],
    ['XS', parseInt(doc.getPropertyValue('--xs'))],
  ]

  breakpoints.sort((a, b) => (a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0))

  const resize = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      breakpoints.some((bp) => {
        let target = entry.target
        let width = entry.contentRect.width
        let current = target.dataset.size

        if (width >= bp[1]) {
          if (current !== bp[0]) {
            target.setAttribute('size', bp[0])
          }
          return true
        }
        return false
      })
    })
  })

  const intersection = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        let target = entry.target
        target.setAttribute('on-screen', entry.isIntersecting)
        target.setAttribute('visible-ratio', (Math.round(entry.intersectionRatio * 4) / 4).toFixed(2))
      })
    },
    {
      threshold: [0, 0.25, 0.5, 0.75, 1],
    },
  )

  class Composition extends Element {
    constructor() {
      super()
    }
  }

  class Component extends Element {
    connectedCallback() {
      if (this.hasAttribute('observe')) {
        ;[...this.children].forEach((c) => (resize.observe(c), intersection.observe(c)))
      }
    }
    constructor() {
      super({ dissolve: true })
    }
  }

  self.customElements.define('blue-composition', Composition)
  self.customElements.define('blue-component', Component)

  self.Initializer = Initializer
  self.Root = Root
}
